import { Component, OnDestroy, OnInit } from "@angular/core";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CoreConfigService } from "@core/services/config.service";
import { DateTime } from "luxon";

@Component({
    selector: "footer",
    templateUrl: "./footer.component.html",
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  public coreConfig: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  get isOesterreichZeitzone(): boolean {
    const utcOffset = DateTime.now().offset;
    const viennaOffset = DateTime.now().setZone("Europe/Vienna").offset;
    return utcOffset === viennaOffset;
  }

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(public _coreConfigService: CoreConfigService) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
